export type LiveRateTableDisplayColumn = { key: string; name?: string };
export type LiveRateTableDisplayBand = {
	rowId?: number;
	displaySn?: number;
	label?: string;
	values?: Record<string, string>;
};

export type LiveRateTableDisplaySnapshot = {
	bands?: LiveRateTableDisplayBand[];
	columns?: LiveRateTableDisplayColumn[];
	taxYear?: string;
};

export type LiveRateTableVisibilityConfig = {
	hiddenColumnKeys?: string[];
	hiddenRowIds?: number[];
};

/** Filter columns and bands for canvas / public render visibility settings. */
export function applyLiveRateTableVisibility<
	T extends LiveRateTableDisplaySnapshot,
>(snapshot: T, config: LiveRateTableVisibilityConfig): T {
	const hiddenColumns = new Set(config.hiddenColumnKeys ?? []);
	const hiddenRows = new Set(config.hiddenRowIds ?? []);
	const columns = (snapshot.columns ?? []).filter(
		(column) => column.key && !hiddenColumns.has(column.key)
	);
	const bands = (snapshot.bands ?? []).filter(
		(band) => typeof band.rowId !== "number" || !hiddenRows.has(band.rowId)
	);
	return { ...snapshot, columns, bands };
}
